import { Services } from '@omnia/ui/src/lib/services'
import { cmsDataService } from './cms.data.service'
import { cmsService } from './cms.service'
import { navigationService } from './navigation.service'
import { UrlService } from './url.service'

export const initServices = () => {
    Services.NavigationService = navigationService as unknown as typeof Services.NavigationService
    Services.CmsDataService = cmsDataService as unknown as typeof Services.CmsDataService
    Services.CmsService = cmsService as unknown as typeof Services.CmsService
    Services.UrlService = new UrlService() as unknown as typeof Services.UrlService
}
